export default "__VITE_ASSET__223cd421__"